// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"afc227d8","161":"0e3ae6f6","270":"57a7eca6","329":"aa8c5fa7"}[chunkId] + ".js";
};